import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import Search from '@ingka/search';
import { useGetTextSearch } from '@/redux/features/code-search/hooks';
import { useAppDispatch } from '@/redux/hooks';
import { setText } from '@/redux/features/code-search/slice';

const SearchTextField: FC = () => {
  const { t } = useTranslation();
  const value = useGetTextSearch();
  const dispatch = useAppDispatch();
  const onSearch = (event: MouseEvent, data: { value: string }) => {
    dispatch(setText(data.value));
  };
  const onClear = () => {
    dispatch(setText(''));
  };

  return (
    <div className="w-full sm:w-[304px]">
      <Search
        value={value}
        data-testid="searchCodes"
        ariaLabel={t('aria.searchCodeField')}
        clearBtnText={t('aria.clearSearchCodeField')}
        defaultValue={value}
        id="searchCodes"
        placeholder={t('label.search')}
        submitBtnText={t('label.submit')}
        onChange={onSearch}
        onSearch={onSearch}
        onClear={onClear}
      />
    </div>
  );
};

export const SearchBar: FC = () => {
  return (
    <div className="w-full flex flex-row justify-start pt-6">
      <SearchTextField />
    </div>
  );
};
